import { schema } from 'normalizr';

const amenity = new schema.Entity('amenity');

export default amenity;
